import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from '../../app.service';
import { CacheService } from '../../cache.service';
import { AuthService } from '../../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

constructor(private appService: AppService, private router: Router, private cacheService: CacheService, private authService: AuthService) {}
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const url = 'auth';
    const tree: UrlTree = this.router.parseUrl(url);


    return this.validateUser(childRoute, state);
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
      return this.validateUser(route, state);
  }

  validateUser(route, state){
    const url = 'logout';
    const tree: UrlTree = this.router.parseUrl(url);


    if(state.url.startsWith('/login') || state.url.startsWith('/auth') || state.url.startsWith('/logout')){
      return true;
    }

    if(this.cacheService.isCurrentUserSameAsGlobalLogin()){
      return true;
    }else{
      return tree;
    }
  }
  
}
